
import { computed, Ref, watch } from "vue";
import { useQuery, useQueryClient } from "@tanstack/vue-query";
import type { PaginacionFilterParams } from "@/utils/PaginacionFilterParams";
import { ListMarcaProductoAction } from "../../actions/marcaActions";

export function useMarcaProductosList(params: Ref<PaginacionFilterParams>) {
  const queryClient = useQueryClient();

  // TanStack Query principal
  const query = useQuery({
    queryKey: ["MarcaProductosList", params],
    queryFn: () => ListMarcaProductoAction(params.value),
    staleTime: 60 * 1000, // cache de 1 minuto
  });

  // Extraer datos en forma reactiva
  const marcas = computed(() => query.data.value?.data?.data?.marcasProductos || []);
  const total = computed(() => query.data.value?.data?.data?.total || 0);
  const totalPages = computed(() => query.data.value?.data?.data?.totalPages || 0);
  const currentPage = computed(() => query.data.value?.data?.data?.page || 1);

  // Prefetch cuando cambien los parámetros
  watch(
    params,
    (newParams) => {
      queryClient.prefetchQuery({
        queryKey: ["MarcaProductosList", newParams],
        queryFn: () => ListMarcaProductoAction(newParams),
      });
    },
    { deep: true }
  );

  return {
    ...query, // => { data, isPending, isError, error, refetch, ... }
    marcas,
    total,
    totalPages,
    currentPage,
  };
}
